// RouteTracker — logs every React Router location change to the diag
// log so we can see in /diagnostics exactly what route the app was on
// when something went wrong. Mounted inside BrowserRouter.
//
// Designed to be invisible (returns null). Mount it once, near the top
// of the route tree.
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { diagLog } from "@/lib/diagnostics";

export default function RouteTracker() {
    const loc = useLocation();
    const prev = useRef(null);

    useEffect(() => {
        const cur = loc.pathname + loc.search + loc.hash;
        const from = prev.current;
        if (from === null) {
            diagLog("info", "route", `MOUNT @${cur}`);
        } else if (from !== cur) {
            diagLog("info", "route", `${from} → ${cur}`);
        }
        prev.current = cur;
    }, [loc]);

    return null;
}
